export default "__VITE_ASSET__df34a789__"